import { ChangeEventHandler, TextareaHTMLAttributes } from "react";

import { CheckIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";

import * as S from "./ReasonOptionSelect.style";

interface ReasonOptionSelectProps {
  selectedOption?: string;
  onSelectOption: (option: string) => void;
  etcTextarea?: {
    labelText: string;
    labelKey?: string;
  } & TextareaHTMLAttributes<HTMLTextAreaElement>;
  checkboxObject: {
    [key: number | string]: number | string;
  };
}

const ReasonOptionSelect = ({
  selectedOption,
  etcTextarea,
  checkboxObject,
  onSelectOption,
}: ReasonOptionSelectProps) => {
  if (typeof checkboxObject !== "object") return null;

  const etcLabelKey = etcTextarea?.labelKey || "etc";
  const checkboxObjWithEtc = {
    ...checkboxObject,
    ...(etcTextarea && {
      [etcLabelKey]: etcTextarea?.labelText,
    }),
  };

  const handleSingleCheckboxChange: ChangeEventHandler<HTMLInputElement> = (
    e,
  ) => {
    onSelectOption(e.target.name);
  };

  return (
    <S.OptionListWrapper>
      {Object.entries(checkboxObjWithEtc).map(([key, value]) => (
        <S.OptionContainer key={key}>
          <S.HiddenCheckbox
            id={key}
            name={key}
            onChange={handleSingleCheckboxChange}
          />
          <S.LabelContainer>
            <S.CheckboxLabel htmlFor={key}>
              <S.CheckboxText name="strongS">{value}</S.CheckboxText>
              {/* isChecked */}
              <S.CheckIconWrapper $isChecked={selectedOption === key}>
                {selectedOption === key && (
                  <CheckIcon size={18} strokeColor={grayScale.white} />
                )}
              </S.CheckIconWrapper>
            </S.CheckboxLabel>

            {selectedOption === etcLabelKey && key === etcLabelKey && (
              <S.ReasonTextarea {...etcTextarea} />
            )}
          </S.LabelContainer>
        </S.OptionContainer>
      ))}
    </S.OptionListWrapper>
  );
};

export default ReasonOptionSelect;
